import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { ChildAccountSettingDirectory } from '../../constants/ComponentTypes';
import Add from '../Icons/Add';
import Tabs, { Tab } from 'material-ui/Tabs';
import IconButton from 'material-ui/IconButton';

const styles = () => ({
  container: {
    width: '100%',
    margin: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    backgroundColor: '#040E35',
    height: '68px',
    boxSizing: 'border-box',
    padding: '0px 0px 0px 20px',
    position: 'relative',
  },

  tabRoot: {
    fontSize: 15,
    textTransform: 'initial',
    transition: "120ms all linear",
    '&:hover, &[aria-selected=true]': {
      borderBottom: '2px solid #FFFFFF',
      color: '#FFFFFF',
      fontWeight: 'bold',
    },
    minWidth: '70px',
    border: 'none',
  },

  textColorPrimary: {
    color: '#71737B',
  },

  labelContainer: {
    padding: '10px 22px',
  },

  indicator: {
    background: 'none',
  },

  buttonContainer: {
    zIndex: 1,
    position: 'absolute',
    right: '25px',
    bottom: 0,
    transform: 'translateY(50%)',
  },

  addButton: {
    marginLeft: '15px',
    background: 'linear-gradient(180deg, #1A65FF, #032FE7)',
    boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.16)',
  },
});

class AccountSettingHeader extends React.Component {

  handleChange = (e, value) => {
    switch (value) {
      case ChildAccountSettingDirectory.ACCOUNT_LIST.name:
        this.props.goTo(ChildAccountSettingDirectory.ACCOUNT_LIST.path);
        break;
      case ChildAccountSettingDirectory.AUTHORITY.name:
        this.props.goTo(ChildAccountSettingDirectory.AUTHORITY.path);
        break;
      case ChildAccountSettingDirectory.OWNER.name:
        this.props.goTo(ChildAccountSettingDirectory.OWNER.path);
        break;
      default:
        break;
    }
  }

  renderLabel = (value) => {
    return (
      <div>
        {value}
      </div>
    )
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Tabs
          value={this.props.childAccountType}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          classes={{
            root: classes.tabsRoot,
            indicator: classes.indicator,
          }}
        >
          {Object.values(ChildAccountSettingDirectory).map((item, i) =>
          (<Tab
            classes={{
              root: classes.tabRoot,
              textColorPrimary: classes.textColorPrimary,
              labelContainer: classes.labelContainer,
            }}
            label={this.renderLabel(item.name)}
            key={i}
            value={item.name}
          >
          </Tab>))}
        </Tabs>

        <div className={classes.buttonContainer}>
          <IconButton
            color="primary"
            className={classes.addButton}
            onClick={this.props.toggleCreateChildAccountDialog}
            title="新規登録"
          >
            <Add width={24} height={24} color="#FFFFFF" />
          </IconButton>
        </div>
      </div>
    );
  }
}

AccountSettingHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  childAccountType: PropTypes.string.isRequired,
  goTo: PropTypes.func.isRequired,
  toggleCreateChildAccountDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(AccountSettingHeader);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/AccountSettingHeader.jsx